import { Navigate, Route, Routes } from 'react-router-dom'
import { BrowserRouter } from 'react-router-dom'

import { AppShell } from './components/layout/AppShell'
import { AssessmentsPage } from './features/assessments/AssessmentsPage'
import { LearningMapPage } from './features/learning-map/LearningMapPage'
import { MaterialsPage } from './features/materials/MaterialsPage'
import { ParentPage } from './features/parent/ParentPage'
import { ReportsPage } from './features/reports/ReportsPage'
import { ReviewPage } from './features/review/ReviewPage'
import { TodayPage } from './features/today/TodayPage'
import { TutorPage } from './features/tutor/TutorPage'
import { AppStateProvider } from './state/AppState'

export function App() {
  return (
    <BrowserRouter>
      <AppStateProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route index element={<Navigate replace to="/today" />} />
            <Route path="/today" element={<TodayPage />} />
            <Route path="/learning-map" element={<LearningMapPage />} />
            <Route path="/tutor" element={<TutorPage />} />
            <Route path="/assessments" element={<AssessmentsPage />} />
            <Route path="/review" element={<ReviewPage />} />
            <Route path="/materials" element={<MaterialsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/parent" element={<ParentPage />} />
          </Route>
          <Route path="*" element={<Navigate replace to="/today" />} />
        </Routes>
      </AppStateProvider>
    </BrowserRouter>
  )
}
